
import { Component } from 'vue-property-decorator';
import Vue from 'vue'
import SinistersList from './components/sinisters/SinistersList.vue'

@Component({
    components: {
        SinistersList
    }
})
export default class PageItemWithSinisters extends Vue {
    async created(){
        // Load properties first (for translations)
        await this.loadProperties();
    }

    async loadProperties(){
        try {
            await this.$store.dispatch('properties/loadProperties');
        } catch (error) {
            console.error('Error loading properties:', error);
        }
    }
}
